import axios from "../axios";
import {
  extractChatUuid,
  extractHostId,
  extractUnitName,
  getStoredChatUuid,
  setStoredChatUuid,
} from "./chatIds";

/**
 * Loads what a guest chat socket needs for this room — the same lookup the
 * host chat runs when it opens: footer/qr-code first, then qr-code as the
 * fallback source of chat_uuid. Rejects with the reason as the error message
 * ("missing_room", "missing_host", "missing_chat_uuid").
 */
export const loadChatContext = async (roomUuid, lang) => {
  if (!roomUuid) throw new Error("missing_room");

  const res = await axios.get(`/${roomUuid}/footer/qr-code`, {
    headers: { lang },
  });
  const data = res?.data?.data || {};
  const hostId = extractHostId(data);
  const unitName = extractUnitName(data);
  let chatUuid = extractChatUuid(data) || getStoredChatUuid(roomUuid);

  if (!chatUuid) {
    try {
      const homeRes = await axios.get(`/${roomUuid}/qr-code`, {
        headers: { lang },
      });
      chatUuid = extractChatUuid(homeRes?.data?.data || {});
    } catch {
      // footer is the primary source; qr-code is only a fallback
    }
  }

  if (!hostId) throw new Error("missing_host");
  if (!chatUuid) throw new Error("missing_chat_uuid");

  setStoredChatUuid(roomUuid, chatUuid);
  return { hostId, unitName, chatUuid };
};
